import {AgentDetails} from 'components/Agent/AgentDetails';
import {connectWithIntl} from 'core/services/connectWithIntl';
import {selectAgentData} from 'features/Agent/AgentDetails/selectors';

const mapStateToProps = () => state => ({
    ...selectAgentData(state),
});

export const AgentDetailsForm = connectWithIntl(mapStateToProps)(AgentDetails);
